<template>
  <donut-chart34-template
    :board-ids="[348]"
    :data-type="dataType"
    field-code="facility"
    :graph-id="73"
    title="(시설물)안전·보건 확보 의무 현황"
    unit="건"
    :orientation="orientation"
  />
</template>

<script>
/* eslint-disable brace-style */
import DonutChart34Template from "@/views/graph/DonutChart34Template.vue";

export default {
  name: 'DonutChart73',
  components: {DonutChart34Template},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
}
</script>

<style scoped>

</style>
